import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

const script: HTMLScriptElement = document.createElement('script');
script.async = false;
script.src = '/lib/highlightjs-line-numbers.min.js';
document.body.appendChild(script);

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
